import { v4 as uuidv4 } from 'uuid';
import { DefaultColumnKeys, IColumnType, IColumnOption, IDataTableColumn } from '../types';

export interface SmallMockItem {
  id: string;
  exclusionsType: SmallMockExclusionsTypes;
  scope: string;
}

interface SmallMockColumn extends IDataTableColumn {
  key: keyof SmallMockItem | DefaultColumnKeys;
}

export enum SmallMockExclusionsTypes {
  Database = 'Database',
  Mailbox = 'Mailbox',
  Network = 'Network',
  User = 'User',
  PublicFolder = 'Public Folder',
}

export const smallMock: {
  columns: SmallMockColumn[];
  items: SmallMockItem[];
} = {
  columns: [
    {
      key: DefaultColumnKeys.REORDER,
      header: '',
      columnType: IColumnType.DISPLAY,
    },
    {
      key: DefaultColumnKeys.PRIORITY,
      header: 'Priority',
      columnType: IColumnType.DISPLAY,
    },
    {
      key: 'scope',
      header: 'Scope',
      columnType: IColumnType.TEXT,
      copyable: true,
    },
    {
      key: 'exclusionsType',
      header: 'Exclusions Type',
      columnType: IColumnType.SINGLE_SELECT,
      options: Object.values(SmallMockExclusionsTypes).map(type => ({ label: type, value: type } as IColumnOption)),
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: 'Actions',
      columnType: IColumnType.DISPLAY,
    },
  ],
  items: [
    {
      id: uuidv4(),
      scope: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse pharetra dolor non neque.',
      exclusionsType: SmallMockExclusionsTypes.Database,
    },
    {
      id: uuidv4(),
      scope: 'Lorem ipsum dolor sit amet',
      exclusionsType: SmallMockExclusionsTypes.Mailbox,
    },
    {
      id: uuidv4(),
      scope: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      exclusionsType: SmallMockExclusionsTypes.PublicFolder,
    },
  ],
};
